import {
  ActivityFlowSection,
  BasicInfoSection,
  InspectionAndImprovementSection,
  LedgerPage,
  RelatedMaterialSection,
} from '@/features/mold/components';
import { BudgetAndExecutionSection } from '@/features/mold/components/pdf/rs-ledger/budget-and-execution-section/BudgetAndExecutionSection';
import { PaymentSection } from '@/features/mold/components/pdf/rs-ledger/payment-section/PaymentSection';
import { PAPER_FILE_SIZE } from '@/features/mold/utils';
import type { FC } from 'react';
import type { useProjectLedgerData } from '../_hooks/useProjectLedgerData';

type Props = {
  projectId: string;
  ledgerData?: ReturnType<typeof useProjectLedgerData>;
  pageId?: string;
};

export const RsProjectLedgerPage: FC<Props> = ({ ledgerData, pageId }) => {
  // ledgerDataが渡されない場合は、以前の実装にフォールバック（互換性のため）
  if (!ledgerData) {
    // ここに以前の実装を残すことも可能ですが、現在は必須として扱います
    return null;
  }

  const {
    isLoading,
    project,
    ministries,
    activityTreeOption,
    nestedConsecutiveIndicators,
    relatedMaterials,
    paymentGroups,
    paymentGraph,
    payments,
    data: { rs },
  } = ledgerData;

  // ローディング中または必要なデータがない場合はnullを返す
  if (
    isLoading ||
    !project ||
    !ministries ||
    !rs.accountingTypes ||
    !rs.accountTitleOptions ||
    !rs.policies
  ) {
    return null;
  }

  return (
    <LedgerPage width={PAPER_FILE_SIZE.A4.height} isLoading={false} id={pageId}>
      <BasicInfoSection ledgerData={ledgerData} />
      <BudgetAndExecutionSection
        project={project}
        consecutiveFiscalYears={rs.consecutiveFiscalYears}
        consecutiveRequestAmounts={rs.consecutiveRequestAmounts}
        consecutiveBudgets={rs.consecutiveBudgets}
        consecutiveExecutions={rs.consecutiveExecutions}
      />
      <ActivityFlowSection
        project={project}
        nestedConsecutiveIndicators={nestedConsecutiveIndicators}
        tree={activityTreeOption.tree.data}
        selectOptions={activityTreeOption.selectOptions}
      />
      <InspectionAndImprovementSection
        project={project}
        accountTitleOptions={rs.accountTitleOptions}
        accountingTypes={rs.accountingTypes}
      />
      <PaymentSection
        project={project}
        paymentGraph={paymentGraph}
        paymentGroups={paymentGroups}
        payments={payments}
      />
      <RelatedMaterialSection relatedMaterials={relatedMaterials} />
    </LedgerPage>
  );
};
